var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import './CaenCodeTile.scss';
var CaenCodeTile = function (props) {
    var caenCode = props.caenCode, isPrimary = props.isPrimary;
    return (_jsxs("div", __assign({ className: "caen-code-tile" }, { children: [_jsxs("div", __assign({ className: "caen-code-tile__pill ".concat(!isPrimary && "caen-code-tile__pill--secondary") }, { children: ["CAEN ", caenCode.Code] })), _jsx("p", __assign({ className: "caen-code-tile__paragraph caen-code-tile__paragraph--last-item" }, { children: caenCode.Name }))] })));
};
export default CaenCodeTile;
